module.exports = __webpack_public_path__ + "static/img/guide5.72a4f7e.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/guide5.webp
// module id = kSeG
// module chunks = 1